module.exports = __webpack_public_path__ + "img/icon_savetime_index.ddddf434.svg";